import { render, staticRenderFns } from "./PaymentMethodInstanceList.vue?vue&type=template&id=1cc85e15&scoped=true"
import script from "./PaymentMethodInstanceList.vue?vue&type=script&lang=js"
export * from "./PaymentMethodInstanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc85e15",
  null
  
)

export default component.exports